<app-apply-shell
    previousRoute="/work-permit"
    previousLabel="Work Permit"
    permitLabel="Work Permit"
    [showForm]="!result"
    outcome="Work permits are reviewed by TLC before approval - it is not issued straight away."
>
    @if (!result) {
        <app-closure-notice></app-closure-notice>
        <ngxh6-form-embed
            [formName]="'work'"
            [options]="{ sticky_actions: false, reload_on_save: false, show_delete: false, show_archive: false }"
            (submitted)="onSubmitted($event)"
        ></ngxh6-form-embed>
    } @else if (result.status === 'active') {
        <app-permit-result state="issued" [email]="result.email" [partySize]="result.partySize" [body]="result.submitMessage">
            <a class="btn btn-primary ms-0" [routerLink]="['/permit', result.token]">View my permit</a>
            <a class="btn btn-outline-secondary ms-0" [href]="pdfUrl" target="_blank" rel="noopener">
                <i class="fa fa-file-pdf me-2" aria-hidden="true"></i>Download PDF
            </a>
        </app-permit-result>
    } @else {
        <app-permit-result state="pending" [email]="result.email" [partySize]="result.partySize" [body]="result.submitMessage">
            <a class="btn btn-primary ms-0" [routerLink]="['/permit', result.token]">Check application status</a>
        </app-permit-result>
    }
</app-apply-shell>
